export const isActive = (pathname: string, href: string | { strict: boolean; href: string }[], strict: boolean = false) => {
  if (Array.isArray(href)) {
    let isMatch = false;
    href.forEach(item => {
      if (!isMatch) {
        const currentItemCheck = !item.strict ? pathname.startsWith(item.href) : pathname === item.href;
        isMatch = currentItemCheck || isMatch;
      }
    });
    return isMatch;
  } else {
    return !strict ? pathname.startsWith(href) : pathname === href;
  }
};
